import React, { PureComponent } from "react"

/* Constants */
import { utils, env } from "../../constants"


/* Component Split */
class Split extends PureComponent {

    render = () => {

        const { onClick } = this.props

        return (
            <div onClick={() => onClick()} className={`game-button split-button`}>
                <img src={`${env.endpoint}/images/buttons/split.png`} alt="split" />
                <p>{utils.translate("SPLIT")}</p>
            </div>
        )
    }

}

export default Split